import React, { useState, useEffect } from "react";

import { RadioGroup } from "@headlessui/react";
import { json, useNavigate, useParams } from "react-router-dom";
import ProductReviewCard from "./ProductReviewCard";
import {
  Box,
  Button,
  Grid,
  LinearProgress,
  Rating,
  Modal,
  TextField,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { findProductById } from "../../../../Redux/Customers/Product/Action";
import { addItemToCart } from "../../../../Redux/Customers/Cart/Action";
import { getAllReviews } from "../../../../Redux/Customers/Review/Action";
import ProductCard from "../ProductCard/ProductCard";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../../config/api";
import { FcLike, FcLikePlaceholder } from "react-icons/fc";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ProductDetails() {
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [userRating, setUserRating] = useState(0); // Store user rating
  const [productRatings, setProductRatings] = useState([]); // Store fetched ratings

  const [selectedSize, setSelectedSize] = useState();
  const [activeImage, setActiveImage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customersProduct, review } = useSelector((store) => store);
  const { productId } = useParams();
  const [averageRating, setAverageRating] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility
  const [reviewText, setReviewText] = useState(""); // Review input

  console.log("productdetails review", review);

  console.log("productID:", productId);
  const [like, setLike] = useState(false);

  const jwt = localStorage.getItem("jwt");

  console.log("product details", customersProduct.product);

  const handleToggleReviews = () => {
    setShowAllReviews((prevShowAll) => !prevShowAll);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      customersProduct &&
      customersProduct.product &&
      customersProduct.product.imageUrl
    ) {
      handleSetActiveImage(customersProduct);
    }
  }, [customersProduct]);

  const handleSetActiveImage = (image) => {
    // console.log( image.product)
    if (image.product) {
      setActiveImage(image.product.imageUrl[0] || image.product.imageUrl[3]);
    } else {
      setActiveImage(image);
    }
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  
  //   // If user is not logged in  navigate  the login page
  //   if (!jwt) {
  //     toast.error("Please log in to add items to the cart");
  //     return;
  //   }

  //   // Check if a size is selected
  //   if (!selectedSize) {
  //     toast.error("Please select a size before adding to cart");
  //     return;
  //   }

  //   console.log("selected size", selectedSize);
  //   // console.log(data);
  //   const data = { productId, size: selectedSize.name || selectedSize };
  //   dispatch(addItemToCart({ data, jwt }));
  //   toast.success("Added to cart!");
  //   setTimeout(() => navigate("/cart"), 800);
  //   if (!jwt) {
  //     navigate("/");
  //   }
  // };


  



  const handleSubmit = async (event) => {
  event.preventDefault();

 

  if (!selectedSize) {
    toast.error("Please select a size before adding to cart");
    return;
  }

  const data = { productId, size: selectedSize.name || selectedSize };

  try {
    // Wait for addItemToCart to succeed
    await dispatch(addItemToCart({ data, jwt })).unwrap;
 if (!jwt) {
    toast.error("Please log in to add items to the cart");
    return;
  }
    toast.success("Added to cart!");
    setTimeout(() => navigate("/cart"), 800);
  } catch (error) {
    // If API fails, show error message and don't navigate
    toast.error(error?.message || "Failed to add product to cart");
  }
};





  const [similarproducts, setsimilarproducts] = useState([]);
  const Getsimilarproducts = async () => {
    try {
      const similarproducts = await api.get(
        `api/products/SimilarProduct/${productId}`
      );
      console.log(
        "similarproducts",
        similarproducts.data.similarProductspriceRange
      );
      setsimilarproducts(similarproducts.data.similarProductspriceRange);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const fetchProductData = async () => {
      console.log("find prod:", productId);
      dispatch(findProductById({ productId, jwt }));
      dispatch(getAllReviews(productId));
      await fetchProductRatings();
      const averageRatingResponse = await api.get(
        `/api/ratings/average/${productId}`
      );
      setAverageRating(averageRatingResponse.data.averageRating);
    };
    fetchProductData();
    setAverageRating();

    Getsimilarproducts();
  }, [productId]);

  console.log("JWT : ", productRatings);

  const fetchProductRatings = async () => {
    try {
      const response = await api.get(`/api/ratings/product/${productId}`);

      console.log("products ratings", response);
      setProductRatings(response.data);
    } catch (error) {
      console.error("Error fetching product ratings", error);
    }
  };

  // Submit rating
  const handleRatingSubmit = async () => {
    if (!jwt) {
      toast.error("Please log in to submit a rating");
      return;
    }

    try {
      const data = {
        productId: productId,
        rating: userRating,
      };

      const response = await api.post("/api/ratings/create", data, {
        headers: { Authorization: `Bearer ${jwt}` },
      });
      // Optimistic update
      setProductRatings((prevRatings) => [...prevRatings, response.data]);

      toast.success("Rating submitted successfully");
      // fetchProductRatings(); // Refresh product ratings after submission
    } catch (error) {
      console.error(
        "Error submitting rating: ",
        error.response || error.message
      );
      toast.error(error.response.data.error);
    }
  };

  const handleReviewSubmit = async () => {
    if (!jwt) {
      toast.error("Please log in to submit a review");
      return;
    }

    try {
      const data = { productId, review: reviewText };
      const review = await api.post("/api/reviews/create", data, {
        headers: { Authorization: `Bearer ${jwt}` },
      });

      toast.success("Review submitted successfully");
      setIsModalOpen(false);
      setReviewText(""); // Clear review input after submission
      dispatch(getAllReviews(productId)); // Refresh reviews after submission
    } catch (error) {
      console.error(
        "Error submitting review: ",
        error.response || error.message
      );
      toast.error(error.response.data.error);
    }
  };

  const fetchWishList = async () => {
    try {
      const response = await api.get("/api/wishlist/get");
      const resp = response.data.wishlist.products;
      console.log("like", response, response.data.wishlist.products);
      const productInWishlist = resp.some((item) => item._id === productId);

      if (productInWishlist) {
        setLike(true);
      } else {
        setLike(false);
      }
    } catch (error) {
      console.log("Error fetching wishlist:", error);
    }
  };

  useEffect(() => {
    fetchWishList();
  }, []);

  const toggleLike = async () => {
    if (!jwt) {
      toast.error("Please log in to add item into wishlist");
      return;
    }

    console.log("product id", productId);

    if (like) {
      console.log("id", productId);
      setLike(false);
      try {
        const response = await api.delete(`/api/wishlist/delete/${productId}`);
        console.log("togglelike", response);
      } catch (e) {
        console.log(e);
      }
    } else {
      setLike(true);
      try {
        const response = await api.post(`/api/wishlist/add/${productId}`);
        console.log("toggleunlike", response);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div className="bg-white lg:px-20">
      <div className="pt-6 h-fit">
        {/* product details */}
        <section className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-2 md:px-4 pt-10">
          <div className="flex justify-evenly lg:justify-between gap-5 items-center ">
            <div className="md:max-w-[20%] max-w-[13%]">
              {Array.isArray(customersProduct.product?.imageUrl) &&
                customersProduct.product.imageUrl.map((url, index) => (
                  <img
                    src={url}
                    alt={`product image ${index + 1}`}
                    className="w-24 cursor-pointer"
                    key={index}
                    onClick={() => handleSetActiveImage(url)}
                  />
                ))}
            </div>
            <div className=" overflow-hidden rounded-lg max-w-[70%] md:max-w-[50%] lg:max-w-[30rem] w-[100%] h-[100%]">
              <img
                src={activeImage || customersProduct.product?.imageUrl}
                alt="product image"
                className="h-full w-fit object-cover object-center"
              />
            </div>
          </div>

          {/* Product info */}
          <div className="lg:col-span-1 mx-auto max-w-2xl px-4 pb-16 sm:px-6  lg:max-w-7xl  lg:px-8 lg:pb-24">
            <div className="lg:col-span-2">
              <h1 className="text-lg lg:text-xl font-semibold tracking-tight text-gray-900  ">
                {customersProduct.product?.brand}
              </h1>
              <h1 className="text-lg lg:text-xl tracking-tight text-gray-900 opacity-60 pt-1">
                {customersProduct.product?.title}
              </h1>
            </div>

            {/* Options */}
            <div className="mt-4 lg:row-span-3 lg:mt-0">
              <h2 className="sr-only">Product information</h2>
              <div className="flex space-x-5 items-center text-lg lg:text-xl tracking-tight text-gray-900 mt-6">
                <p className="font-semibold">
                  ₹{customersProduct.product?.discountedPrice}
                </p>
                <p className="opacity-50 line-through">
                  ₹{customersProduct.product?.price}
                </p>
                <p className="text-green-600 font-semibold">
                  {customersProduct.product?.discountPersent ||100-Math.round(customersProduct.product?.discountedPrice*100/customersProduct.product?.price)}% Off
                </p>
              </div>

              <form className="mt-10" onSubmit={handleSubmit}>
                {/* Sizes */}
                <div className="mt-10">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-medium text-gray-900">Size</h3>
                  </div>

                  <RadioGroup
                    value={selectedSize}
                    onChange={setSelectedSize}
                    className="mt-4"
                  >
                    <RadioGroup.Label className="sr-only">
                      Choose a size
                    </RadioGroup.Label>
                    <div className="grid grid-cols-4 gap-6 sm:grid-cols-8 lg:grid-cols-10">
                      {Array.isArray(customersProduct.product?.sizes) &&
                        customersProduct.product.sizes.map((size) => (
                          <RadioGroup.Option
                            key={size.name}
                            value={size.name}
                            disabled={size.quantity < 0}
                            className={({ active }) =>
                              classNames(
                                size.quantity > 0
                                  ? "cursor-pointer bg-white text-gray-900 shadow-lg px-6"
                                  : "cursor-not-allowed bg-gray-50 text-gray-200",
                                active ? "ring-1 ring-indigo-500" : "",
                                "group relative flex items-center justify-center rounded-md border py-1 px-1 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6"
                              )
                            }
                          >
                            {({ active, checked }) => (
                              <>
                                <RadioGroup.Label as="span">
                                  {size.name}
                                </RadioGroup.Label>
                                {size.quantity > 0 ? (
                                  <span
                                    className={classNames(
                                      active ? "border" : "border-2",
                                      checked
                                        ? "border-indigo-500"
                                        : "border-transparent",
                                      "pointer-events-none absolute -inset-px rounded-md"
                                    )}
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <span
                                    aria-hidden="true"
                                    className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200"
                                  >
                                    <svg
                                      className="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                      viewBox="0 0 100 100"
                                      preserveAspectRatio="none"
                                      stroke="currentColor"
                                    >
                                      <line
                                        x1={0}
                                        y1={100}
                                        x2={100}
                                        y2={0}
                                        vectorEffect="non-scaling-stroke"
                                      />
                                    </svg>
                                  </span>
                                )}
                              </>
                            )}
                          </RadioGroup.Option>
                        ))}
                    </div>
                  </RadioGroup>
                </div>
                <div className="mt-12 flex space-x-20">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      padding: ".8rem 2rem",
                      backgroundColor: "#854d0e",
                      "&:hover": {
                        backgroundColor: "#6d3e0b", // Darker shade for hover effect
                      },
                      width: "max-content",
                    }}
                    
                  >
                    Add To Cart
                  </Button>

                  <Button onClick={toggleLike} className="wishlist-btn">
                    <span role="img" aria-label="Wishlist">
                      {like ? (
                        <FcLike className="text-3xl " />
                      ) : (
                        <FcLikePlaceholder className="text-3xl" />
                      )}
                    </span>{" "}
                    {/* Heart emoji */}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </section>

        {/* rating and review section */}
        <section className="md:m-9">
          <div className="border p-6 ">
            <Grid
              container
              spacing={4}
              sx={{
                flexDirection: { xs: "column", md: "row" }, // Stack on mobile, side by side on desktop
                width: "100%",
              }}
            >
              {/* Left Section - Rating & Reviews */}
              <Grid
                item
                xs={12} // Full width on mobile
                md={7} // Takes 7/12 on desktop
                sx={{
                  width: "100%",
                  px: { xs: 2, md: 4 }, // Padding responsive
                }}
              >
                {/* Submit Rating */}
                <div className="my-6 w-full flex flex-col">
                  <div className="flex flex-wrap items-center justify-between w-full">
                    <h2 className="text-lg font-medium text-gray-900">
                      Submit Your Rating
                    </h2>

                    <Rating
                      name="user-rating"
                      value={userRating}
                      precision={0.5}
                      onChange={(event, newValue) => setUserRating(newValue)}
                    />
                  </div>

                  {/* Buttons */}
                  <div className="flex flex-wrap justify-center md:justify-start mt-5 gap-4">
                    <Button
                      variant="contained"
                      onClick={handleRatingSubmit}
                      sx={{
                        padding: ".4rem 1rem",
                        backgroundColor: "#854d0e",
                        "&:hover": {
                          backgroundColor: "#6d3e0b",
                        },
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        padding: ".4rem 1rem",
                        backgroundColor: "#854d0e",
                        "&:hover": {
                          backgroundColor: "#6d3e0b",
                        },
                      }}
                      onClick={() => setIsModalOpen(true)}
                    >
                      Review
                    </Button>
                  </div>

                  {/* Review Modal */}
                  <Modal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                  >
                    <div className="bg-white p-6 rounded-md w-[90%] md:w-[500px] mx-auto mt-20">
                      <h2 className="text-lg font-medium mb-4">
                        Write a Review
                      </h2>
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="Write your review here..."
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)}
                      />
                      <div className="mt-4 flex justify-end gap-3">
                        <Button
                          onClick={handleReviewSubmit}
                          variant="contained"
                          sx={{
                            backgroundColor: "#854d0e",
                            "&:hover": { backgroundColor: "#6d3e0b" },
                          }}
                        >
                          Submit Review
                        </Button>
                        <Button
                          onClick={() => setIsModalOpen(false)}
                          sx={{
                            color: "white",
                            backgroundColor: "#854d0e",
                            "&:hover": { backgroundColor: "#6d3e0b" },
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </Modal>
                </div>

                {/* Review List */}
                <div className="space-y-5">
                  {(showAllReviews
                    ? review.reviews
                    : review.reviews?.slice(0, 2)
                  )?.map((item, i) => (
                    <ProductReviewCard key={i} item={item} />
                  ))}
                </div>

                {review.reviews?.length > 2 && (
                  <div className="mt-4 flex justify-center md:justify-start">
                    <Button onClick={handleToggleReviews}>
                      {showAllReviews ? "Show Less" : "View All"}
                    </Button>
                  </div>
                )}
              </Grid>

              {/* Right Section - Product Ratings */}
              <Grid
                item
                xs={12} // Full width on mobile
                md={5} // Takes 5/12 on desktop
                sx={{
                  mt: { xs: 6, md: 0 },
                  px: { xs: 2, md: 4 },
                }}
              >
                <h1 className="text-xl font-semibold pb-2">Product Ratings</h1>

                {/* Overall rating */}
                <div className="flex items-center space-x-3 pb-6">
                  <Rating
                    name="read-only"
                    value={averageRating}
                    precision={0.5}
                    readOnly
                  />
                  <p className="opacity-60">
                    {averageRating}
                    <span className="ml-3">Ratings</span>
                  </p>
                </div>

                {/* Progress rows */}
                <div className="space-y-4">
                  {[
                    {
                      label: "Excellent",
                      color: "bg-green-500",
                      width: "40%",
                      count: 19259,
                    },
                    {
                      label: "Very Good",
                      color: "bg-green-500",
                      width: "30%",
                      count: 19259,
                    },
                    {
                      label: "Good",
                      color: "bg-yellow-600",
                      width: "25%",
                      count: 19259,
                    },
                    {
                      label: "Average",
                      color: "bg-yellow-700",
                      width: "21%",
                      count: 19259,
                    },
                    {
                      label: "Poor",
                      color: "bg-red-500",
                      width: "10%",
                      count: 19259,
                    },
                  ].map((row, i) => (
                    <div className="flex items-center gap-3" key={i}>
                      <div className="w-3/12 sm:w-2/12">
                        <p className="text-sm">{row.label}</p>
                      </div>
                      <div className="w-7/12">
                        <div className="w-full bg-gray-300 rounded-full h-[7px] overflow-hidden">
                          <div
                            className={`${row.color} h-[7px] rounded-full`}
                            style={{ width: row.width }}
                          />
                        </div>
                      </div>
                      <div className="w-2/12 text-right opacity-50 text-sm">
                        {row.count}
                      </div>
                    </div>
                  ))}
                </div>
              </Grid>
            </Grid>
          </div>
        </section>

        {/* similer product */}
        <section className=" pt-10">
          <h1 className="py-5 text-xl font-bold">Similar Products</h1>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {similarproducts.map((item, i) => (
              <ProductCard key={i} product={item} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
